import { RuntimeGS } from '../core/app/RuntimeGS';

export function addAttrs(el: Element, attrs: object) {
    if (!attrs) return;
    const values = attrs as Record<string, any>;
    for (const attr in values) el.setAttribute(attr, values[attr]);
}

export function addText(el: Element, text: string) {
    el.appendChild(RuntimeGS.document.createTextNode(text));
}

export function addSpace(el: Element) {
    el.appendChild(RuntimeGS.document.createTextNode(' '));
}

function createAndFillElement(tag: string, inner = "", attrs: Record<string, any> = {}): Element {
    const el = RuntimeGS.document.createElement(tag);
    el.innerHTML = inner;
    addAttrs(el, attrs);
    return el;
}

export function span(attrs = {}, inner = ""): HTMLSpanElement { return createAndFillElement('span', inner, attrs) as HTMLSpanElement; }
export function p(attrs = {}, inner = ""): HTMLParagraphElement { return createAndFillElement('p', inner, attrs) as HTMLParagraphElement; }
export function a(attrs = {}, inner = ""): HTMLAnchorElement { return createAndFillElement('a', inner, attrs) as HTMLAnchorElement; }
export function div(attrs = {}, inner = ""): HTMLDivElement { return createAndFillElement('div', inner, attrs) as HTMLDivElement; }
export function br(attrs = {}): HTMLBRElement { const el = RuntimeGS.document.createElement('br'); addAttrs(el, attrs); return el as HTMLBRElement; }
export function hr(attrs = {}): HTMLHRElement { const el = RuntimeGS.document.createElement('hr'); addAttrs(el, attrs); return el as HTMLHRElement; }
export function img(attrs = {}): HTMLImageElement { const el = RuntimeGS.document.createElement('img'); addAttrs(el, attrs); return el as HTMLImageElement; }
export function tag(tagName: string, attrs = {}, inner = ''): HTMLElement { const el = RuntimeGS.document.createElement(tagName); addAttrs(el, attrs); el.innerHTML = inner; return el; }

export function textToElement(text: string): Element | null {
    return div({}, text).firstElementChild;
}
